/*global AmCharts, App */

Components.Energy.Manager.SummaryChart = function (container, loadDataLink) {
    /* private */
    var _chart;
    var dataUpdatedEvent = function () {
        for (var s in _chart.dataSets) {
            var set = _chart.dataSets[s];
            if (typeof set === "undefined") continue;
            if (set.dataProvider) {
                var nullable = true;
                for (var r in set.dataProvider) {
                    var record = set.dataProvider[r];
                    if (record.value !== null) nullable = false;
                }
                if (nullable) {
                    var graph = _chart.panels[0].graphs[s];
                    _chart.panels[0].hideGraph(graph);
                }
            }
        }
    };
    var createChart = function () {
        _chart = new AmCharts.AmStockChart();
        _chart.colors = App.Ui.getColors();
        _chart.language = "cz";
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.dataSets = [];
        _chart.export = App.Charts.export;

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.title = "Spotřeba";
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        stockPanel.stockLegend = {valueTextRegular: "[[value]]Wh", periodValueTextComparing: "[[value]]Wh"};
        _chart.panels = [stockPanel];

        var graph = new AmCharts.StockGraph();
        graph.type = "column";
        graph.valueField = "value";
        graph.periodValue = "Sum";
        graph.comparable = true;
        graph.compareField = "value";
        graph.compareGraphType = "column";
        graph.compareGraphFillAlphas = 1;
        graph.showBalloon = false;
        graph.fillAlphas = 1;
        stockPanel.addStockGraph(graph);

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.unit = "Wh";
        valueAxesSettings.showFirstLabel = true;
        valueAxesSettings.inside = false;
        _chart.valueAxesSettings = valueAxesSettings;
        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.minPeriod = "hh";
        _chart.categoryAxesSettings = categoryAxesSettings;

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 80;
        _chart.panelsSettings = panelsSettings;
        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.valueLineEnabled = true;
        cursorSettings.valueLineBalloonEnabled = true;
        cursorSettings.zoomable = false;
        cursorSettings.fullWidth = true;
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.valueLineAlpha = 0.5;
        _chart.chartCursorSettings = cursorSettings;
        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.enabled = false;
        _chart.chartScrollbarSettings = scrollbarSettings;

        _chart.addListener("dataUpdated", dataUpdatedEvent);

        _chart.write(container);
        loadData();
    };
    var loadData = function () {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function () {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function (result) {
                if (result.dataSets && result.dataSets.length > 0) {
                    prepareDataForChart(result.dataSets);
                } else {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                }
            },
            error: function () {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var prepareDataForChart = function (data) {
        _chart.dataSets = [];
        for (var i in data) {
            var set = data[i];
            var dataProvider = [];
            for (var index in set.records) {
                var record = set.records[index], consumption;
                var consumption = record.powerConsumptionActive;
                var date = new Date(record.timestamp * 1000);
                dataProvider.push({Datum: date, value: consumption});
            }
            if (typeof date !== "undefined") {
                date = new Date(date.getTime() + 15 * 60 * 1000);
                dataProvider.push({Datum: date, value: null});
            }

            var dataset = new AmCharts.DataSet();
            dataset.title = set.name;
            dataset.fieldMappings = [{fromField: "value", toField: "value"}];
            dataset.dataProvider = dataProvider;
            dataset.categoryField = "Datum";
            dataset.compared = true;
            dataset.color = App.Ui.getColors()[i];

            if (dataProvider.length > 0) _chart.dataSets.push(dataset);
        }
        if (_chart.dataSets.length > 0) _chart.validateData();
        else _chart.clear();
    };
    /* public */
    /* construct */
    createChart();
};
